import styled from 'styled-components'

export const Body = styled.div``

export const Spacer = styled.div`
  margin-top: 24px;
`
